<template>
  <div class="section-progress" :class="{ 'no-bar': currentSection > 0 }">
    <div class="progress-bar">
      <div class="progress-track">
        <button
          v-for="(section, index) in 6"
          :key="index"
          class="progress-dot"
          :class="{ 'is-active': currentSection === index }"
          @click="$emit('go-to', index)"
        >
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionProgress',
  props: {
    currentSection: {
      type: Number,
      default: 0
    }
  },
  emits: ['go-to']
}
</script>

<style scoped>
.section-progress {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  width: 100px;
}

.progress-bar {
  width: 100%;
  height: 100%;
  background: var(--sub-color);
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-track {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
}

.progress-dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  border: none;
  background: var(--thehue-primary);
  opacity: 0.3;
  cursor: pointer;
  padding: 0;
  transition: all 0.3s ease;
}

.progress-dot.is-active {
  width: 6px;
  height: 6px;
  opacity: 1;
  box-shadow: 0 0 0 6px rgba(0, 69, 56, 0.1);
}

/* 2섹션부터: 배경만 투명, 크기 유지 */
.section-progress.no-bar .progress-bar {
  background: transparent;
}

/* 모바일에서 숨김 */
@media (max-width: 768px) {
  .section-progress {
    display: none;
  }
}
</style>
